import { loadable } from '@shared/core/loadableFromNamedExport';

/**
 * Kept lazy so the `control` arm — which never renders it — ships none of this code.
 * This chunk holds only the variant switch; each treatment has its own chunk, so a bucketed guest
 * downloads one design rather than both. See `FeaturedPlacements.tsx`.
 */
export const FeaturedPlacements = loadable(() => import(/* webpackChunkName: "stays/featured-placements" */ '.'), 'FeaturedPlacements');
